import { CvpLocale } from "../constants/CvpLocale";
import { useSettings } from "../settings/useSettings";
import { CVPSearchParams, queryStringStore } from "../url/wsQueryStringStore";
import { useWhoAmI } from "../user/useWhoAmI";
import { lp } from "../utils/logPrefix";
import { validateLocale } from "./validateLocale";

/** See also useSetLocale() */
export function useEvaluatedLocale() {
  const settings = useSettings();
  const { whoAmI } = useWhoAmI();
  const localeFromQs =
    queryStringStore.qs[CVPSearchParams.cvplocale]?.toString();

  if (settings?.iframe_overrideLocale) {
    const isValid = validateLocale(settings?.iframe_overrideLocale);

    if (isValid) {
      return settings?.iframe_overrideLocale;
    }

    console.error(
      lp(),
      "Invalid locale from settings?.iframe_overrideLocale",
      settings?.iframe_overrideLocale
    );
  }

  // locale fra querystring (f.eks &cvplocale=en)
  if (localeFromQs) {
    const isValid = validateLocale(localeFromQs);

    if (isValid) {
      return localeFromQs as CvpLocale;
    }

    console.error(lp(), "Invalid locale from query string", localeFromQs);
  }

  // locale fra auth/WhoAmI    (oppdatert med authAPI.saveLocaleChoice)
  if (whoAmI.locale) {
    const isValid = validateLocale(whoAmI.locale);

    if (isValid) {
      return whoAmI.locale as CvpLocale;
    }

    console.error(lp(), "Invalid locale from WhoAmI", whoAmI.locale);
  }

  // locale fra sessionStorage.getItem("locale")
  if (sessionStorage.getItem("locale")) {
    const isValid = validateLocale(sessionStorage.getItem("locale") as string);

    if (isValid) {
      return sessionStorage.getItem("locale") as CvpLocale;
    }

    console.error(
      lp(),
      "Invalid locale from sessionStorage",
      sessionStorage.getItem("locale")
    );
  }

  // locale fra settings (velges i /admin)
  if (settings?.locale) {
    const isValid = validateLocale(settings?.locale);

    if (isValid) {
      return settings?.locale;
    }

    console.error(
      lp(),
      "Invalid locale from settings?.locale",
      settings?.locale
    );
  }

  // fallback til nb
  return CvpLocale.nb;
}
